<template>
  <div>
    <!-- <label class="typo__label" for="ajax">Async multiselect</label> -->
    <multiselect
      v-model="output"
      :track-by="id"
      :label="label"
      :options="options"
      :multiple="true"
      :close-on-select="false"
      :clear-on-select="true"
      :preserve-search="true"
      :placeholder="$lang.multiselect.placeholder"
      :searchable="true"
      :allow-empty="true"
      :show-labels="true"
      :selectLabel="$lang.multiselect.selectLabel"
      :selectedLabel="$lang.multiselect.selectedLabel"
      :class="
        isValid === null
          ? ''
          : isValid
          ? 'multiselect__valid'
          : 'multiselect__invalid'
      "
      @input="updateValue"
      :loading="loading"
      :internal-search="false"
      :max-height="600"
      :hide-selected="true"
      @search-change="delaySearch"
    >
      <template slot="noOptions">
        <strong>{{ $lang.multiselect.noOptions }}</strong>
      </template>
      <template slot="noResult">
        <strong>{{ $lang.multiselect.noResult }}</strong>
      </template>
      <template slot="singleLabel" slot-scope="{ option }">
        <span>{{ option[label] }}</span>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    isValid: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    asyncFind: {
      type: Function,
      default: null,
    },
    selectItem: {
      type: Function,
      default: null,
    },
    removeItem: {
      type: Function,
      default: null,
    },
    debounceTime: {
      type: Number,
      default: 800,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedCountries: [],
      output: this.value,
      debounceGet: null,
    };
  },
  methods: {
    updateValue() {
      this.$emit("input", this.output);
    },
    delaySearch(value) {
      if (this.debounceGet) {
        clearTimeout(this.debounceGet);
        this.debounceGet = null;
      }
      this.debounceGet = setTimeout(
        () => this.asyncFind(value),
        this.debounceTime
      );
    },
  },
};
</script>

<style>
</style>
